import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BreadcrumbService } from '@suvo/frontend/standalone/breadcrumb';
import { ITableDataSource } from '@suvo/frontend/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/shared/interfaces/table-data-source.interface';
import { Subject } from 'rxjs';
import { ITaxon } from '../../../taxon/taxon.interface';
import { TaxonService } from '../../../taxon/taxon.service';
import { TaxonLineageComponent } from '../../components/taxon-lineage/taxon-lineage.component';

@Component({
  template: `
    @if (!taxon) {
      <suvo-core-loading-spinner />
    } @else {
      <app-taxon-overview [isTopLevelTaxon]="false" [taxon]="taxon" (save)="onSave()" />
      @if (taxon.history) {
        <app-taxon-history [taxon]="taxon" />
      }
      <app-taxon-lineage #lineage [isTopLevelTaxon]="false" [taxon]="taxon" />
    }
  `,
})
export class KnowledgeBaseTaxonScreenComponent implements OnInit, OnDestroy {
  @ViewChild('lineage') lineage: TaxonLineageComponent;
  private readonly unsubscribe$ = new Subject<void>();

  taxon: ITaxon;
  searchResults: ITableDataSource<ITaxon>;
  taxonId;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly breadcrumb: BreadcrumbService,
    private readonly taxaDirectory: TaxonService,
  ) {}

  ngOnInit() {
    this.activatedRoute.params.subscribe(async (data) => {
      if (data.id) {
        this.taxonId = data.id;
        this.taxon = await this.taxaDirectory.getById(data.id);
        this.breadcrumb.setDynamicNameSwap(
          'id',
          this.taxon.taxonName + ` (${this.taxon.cprTaxonId})`,
        );
      } else {
        this.taxon = {
          taxonName: '',
          oldRankId: 1,
          isOnlyEverPlussed: false,
          rank: 'SPECIES',
        };
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  async onSave() {
    this.taxon = await this.taxaDirectory.getById(this.taxonId);
    this.breadcrumb.setDynamicNameSwap('id', this.taxon.taxonName + ` (${this.taxon.cprTaxonId})`);

    this.lineage.refresh();
  }
}
